module.exports = __webpack_public_path__ + "img/06.65fd6198.png";